import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateText',
    standalone: false
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string, length: number): string {
    if (value && typeof value === 'string' && value.length > length) {
      return value.slice(0, length) + '...';
    }
    return value;
  }
}
